module.exports = __webpack_public_path__ + "static/img/5-1.a0bd752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/paixu/5-1.png
// module id = HLax
// module chunks = 6